import CreateContestViewContainer from 'components/Contest/containers/ContestViewContainer';
import ContestView from 'components/Contest/layouts/ContestView';
import ColumnsContent from 'components/Hocs/ColumnsContent';

export default ColumnsContent(CreateContestViewContainer(ContestView));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/ContestView/ContestView.js